export const setUsername = (username) => {
  return {
    type: 'SET_USERNAME',
    username
  }
}



/** WEBPACK FOOTER **
 ** ./src/actions/users.js
 **/